import { FullScreenDialog } from "@src/appV2/lib/Dialogs/FullScreen/Dialog";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useEffect, useState } from "react";

import { PolicyAcknowledgementStep } from "./steps/PolicyAcknowledgementStep";
import { ProvideExplanationStep } from "./steps/ProvideExplanationStep";

type Step = "policy" | "explanation";

interface WorkedThroughMandatoryBreakExplanationDialogProps {
  modalState: UseModalState;
  workplaceName: string;
  breakPolicy: string;
  mandatoryBreakDurationInMinutes: number;
  onSuccess: (explanation: string) => void;
}

export function WorkedThroughMandatoryBreakExplanationDialog(
  props: WorkedThroughMandatoryBreakExplanationDialogProps
) {
  const { modalState, workplaceName, breakPolicy, mandatoryBreakDurationInMinutes, onSuccess } =
    props;
  const [currentStep, setCurrentStep] = useState<Step>("policy");

  // Reset to first step when modal closes (prevents UI stutter on reopen)
  useEffect(() => {
    if (!modalState.modalIsOpen) {
      setCurrentStep("policy");
    }
  }, [modalState.modalIsOpen]);

  return (
    <FullScreenDialog modalState={modalState} variant="tertiary">
      {currentStep === "policy" ? (
        <PolicyAcknowledgementStep
          workplaceName={workplaceName}
          breakPolicy={breakPolicy}
          mandatoryBreakDurationInMinutes={mandatoryBreakDurationInMinutes}
          onContinue={() => {
            setCurrentStep("explanation");
          }}
          onBack={() => {
            modalState.closeModal();
          }}
        />
      ) : null}
      {currentStep === "explanation" ? (
        <ProvideExplanationStep
          workplaceName={workplaceName}
          mandatoryBreakDurationInMinutes={mandatoryBreakDurationInMinutes}
          onBack={() => {
            setCurrentStep("policy");
          }}
          onSubmit={(explanation) => {
            onSuccess(explanation);
          }}
        />
      ) : null}
    </FullScreenDialog>
  );
}
